import { FC } from 'react';
import EmojiIcon, { EmojiOption } from '../EmojiIcon';

interface ReactionItemProps {
  emoji: EmojiOption;
  count: number;
  isUserReaction: boolean;
  onClick: (emojiId: string) => void;
  isPulsingUp?: boolean;
  isPulsingDown?: boolean;
  className?: string;
}

const CommentReactionItem: FC<ReactionItemProps> = ({
  emoji,
  count,
  isUserReaction,
  onClick,
  isPulsingUp,
  isPulsingDown,
  className = '',
}) => {
  const reactionClasses = [
    'reaction-item',
    isUserReaction ? 'reaction-item-active' : 'bg-[#ebebeb]',
    isPulsingUp ? 'reaction-item-pulsing-up' : '',
    isPulsingDown ? 'reaction-item-pulsing-down' : '',
    className,
  ].join(' ');

  return (
    <button
      type="button"
      key={emoji.id}
      className={reactionClasses}
      onClick={() => onClick(emoji.id)}
    >
      <EmojiIcon
        symbol={emoji.native}
        size={className.includes('reaction-button') ? 20 : 18}
      />
      {count > 0 && (
        <span
          className={className.includes('reaction-button') ? 'ml-1' : undefined}
        >
          {count}
        </span>
      )}
    </button>
  );
};

export default CommentReactionItem;
